import * as Sentry from '@sentry/browser'
import loadVideo from 'guardian-liveness-detection-lib/src/libs/loadVideo'

export async function loadHandler(
  file: File,
  loadTimeoutHandler: (el: HTMLVideoElement) => Promise<void>): Promise<{
    file: File,
    video?: HTMLVideoElement,
  }> {
  // tslint:disable-next-line
  let video: undefined | HTMLVideoElement = undefined
  try {
    video = await loadVideo(window.URL.createObjectURL(file), {
      loadTimeout: 1000,
      loadTimeoutHandler,
    })
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
  }
  return { file, video }
}
